module.exports = __webpack_public_path__ + "img/16.2cbd70e3.png";